// extracted by mini-css-extract-plugin
export var author = "Review-module--author--3HDCq";
export var quote = "Review-module--quote--76m5C";
export var title = "Review-module--title--vbjdd";
export var wrapper = "Review-module--wrapper--gArzs";